var map = {
	"./address.svg": "7c5f",
	"./arrow-down.svg": "b4c8",
	"./arrow-left.svg": "f6db",
	"./back.svg": "7e60",
	"./bottle.svg": "1305",
	"./cart.svg": "c0c3",
	"./clip.svg": "e533",
	"./close.svg": "bb7c",
	"./cook.svg": "4106",
	"./facebook.svg": "7e4b",
	"./gift.svg": "6953",
	"./instagram.svg": "48d6",
	"./list.svg": "484a",
	"./phone.svg": "1f9a",
	"./placeholder.svg": "1311",
	"./recycle.svg": "b1f4",
	"./rub.svg": "6076",
	"./search.svg": "0a17",
	"./smile.svg": "cd22",
	"./telegram.svg": "e44e",
	"./time.svg": "6fc1",
	"./vk.svg": "b6d9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";